export const FETCHBLOG = 'FETCHBLOG';
export const FETCH_BLOG_BY_SEARCH = 'FETCH_BLOG_BY_SEARCH';
export const CREATEBLOG = 'CREATEBLOG';
export const DELETE = 'DELETE';
export const UPDATE = 'UPDATE';
export const LIKE = 'LIKE';

export const    AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';